import  React from 'react';

import {ContinueButton, BackButton} from './button.jsx';

export const Navigator = ({continueText, backText, onContinue, onBack, continueDisabled = false, backDisabled = false, noContinue=false, noBack=false}) => {
  return(
    <div className="navigator">
      { !noBack &&
       <BackButton
         className="btn"
         disabled={backDisabled}
         text={backText}
         onButtonClick={onBack}
       />
      }
      { noBack &&
      <BackButton
        className="btn"
        disabled={true}
        text={""}
        onButtonClick={() => {}}
      />
      }
      { !noContinue &&
      <ContinueButton
        className="btn"
        disabled={continueDisabled}
        text={continueText}
        onButtonClick= {onContinue}
      />
      }
    </div>
  );
}
